export default {
  Pending: 'pending',
  Success: 'success',
  Error: 'error'
};



// WEBPACK FOOTER //
// ./src/javascripts/app/widgets/structured_text/plugins/shared/RequestStatus.es6.js